// Convert a number (or numeric string) to a plain decimal string without
// scientific notation. Handles very small / very large numbers safely.
export const toPlainString = (num) => {
    if (num === null || num === undefined || num === "" || isNaN(num)) return "0";
    const n = Number(num);
    if (n === 0) return "0";
    const str = typeof num === "string" ? num : n.toString();
    if (!/e/i.test(str)) return str;
    // Use toFixed with a high precision to avoid exponent form, then trim.
    const fixed = n.toFixed(30);
    return fixed.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
};

// Truncate (no rounding) a number to a given number of decimals and return a
// string safe to pass into ethers.parseUnits.
export const safeFixedString = (num, decimals) => {
    if (num === null || num === undefined || num === "" || isNaN(num)) return "0";
    if (Number(num) === 0) return "0";
    const d = Number(decimals) || 0;
    const str = toPlainString(num);
    const dotIndex = str.indexOf(".");
    if (dotIndex === -1) return str;
    if (d === 0) return str.slice(0, dotIndex);
    return str.slice(0, dotIndex + 1 + d);
};
